import {
  getApplications,
  getPendingStatus,
  postApplication,
  putApplication,
} from "../../api";
import { createSliceWithThunks } from "../utils";

const initialState = {
  get: {
    status: "idle",
    data: [],
    error: null,
  },
  checkPending: {
    status: "idle",
    data: null,
    error: null,
  },
  post: {
    status: "idle",
    data: null,
    error: null,
  },
  put: {
    status: "idle",
    data: null,
    error: null,
  },
  formValues: {},
};

export const authSlice = createSliceWithThunks({
  name: "applications",
  initialState: initialState,
  reducers: (create) => ({
    resetStateApplications: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    setFormValues: create.reducer((state, { payload }) => {
      state.formValues = payload;
    }),

    //* thunks
    fetchApplications: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getApplications(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              state.get.data = respObj;
              state.get.error = null;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),
    checkPendingApplication: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getPendingStatus(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.checkPending.status = "loading";
        },
        rejected: (state, action) => {
          state.checkPending.status = "failed";
          state.checkPending.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.checkPending.error = { message: respObj };
            } else if (status === "success") {
              state.checkPending.data = respObj;
              state.checkPending.error = null;
            }
          } else {
            state.checkPending.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.checkPending.status = "idle";
        },
      }
    ),
    addApplication: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postApplication(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
              state.post.error = null;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
    updateApplication: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putApplication(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.put.error = { message: respObj };
            } else if (status === "success") {
              state.put.data = respObj;
              state.put.error = null;
            }
          } else {
            state.put.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
  }),
});

export const {
  resetStateApplications,
  fetchApplications,
  addApplication,
  updateApplication,
  setFormValues,
  checkPendingApplication,
} = authSlice.actions;
export default authSlice.reducer;
